import { apiRequest } from './httpClient';

// PUBLIC: works logged out (backend/routers/contact.py has no auth
// dependency) - a visitor asking about a Custom plan has no account yet.

// The reasons the API accepts (backend/schemas/contact.py's
// ContactReason). The form has no reason field: it is "general" unless
// the visitor arrived from the pricing Custom card, whose link carries
// ?reason=custom-plan.
export const CONTACT_REASONS = ['general', 'custom_plan', 'other'];

// Mirrors the backend's limits so a mistake is caught before the request
// - the backend still enforces every one of them itself.
export const CONTACT_LIMITS = {
  nameMax: 100,
  messageMin: 10,
  messageMax: 5000,
};

// Only what the visitor typed, plus the reason. There is deliberately no
// recipient here: where the message goes is decided by the server alone,
// and the backend rejects any field it does not know.
export function sendContactMessage({ name, email, reason, message }) {
  return apiRequest('/api/contact', {
    method: 'POST',
    body: { name, email, reason, message },
  });
}
